export default "__VITE_ASSET__dsKpwBaV__"